<template>
  <div class="newActivity">
    <div class="breadcrumb">
      活动管理 >
      <span v-if="edit === false">新增</span>
      <span v-if="edit !== false">编辑</span>
      <span>
        <el-button class="right_f" type="primary" @click="cancel"
          >取消</el-button
        >
        <el-button class="right_f" type="primary" @click="save">保存</el-button>
      </span>
    </div>

    <div class="detail">
      <el-form
        ref="activityForm"
        :rules="rules"
        :model="activityForm"
        label-width="170px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动名称:" prop="name">
              <el-input
                v-model="activityForm.name"
                class="activityTitle"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动类型:" prop="activityType" required>
              <el-select
                v-model="activityForm.activityType"
                class="activityType"
              >
                <el-option label="跑步奖励" value="1"></el-option>
                <el-option label="其他活动" value="2"></el-option>
                <el-option label="室内锻炼" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="封面图:" prop="bigImageUrl">
              <!-- <el-upload
                :action="actionUrl"
                :with-credentials="true"
                accept="image/*"
                name="uploadFile"
                type="drag"
                :thumbnail-mode="true"
                :on-error="handleError"
                :on-success="chenggong"
               
              >
                <i class="el-icon-upload"></i>
                <div class="el-dragger__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload> -->
              <el-upload
                :action="actionUrl"
                :with-credentials="true"
                :show-file-list="false"
                accept="image/*"
                name="uploadFile"
                type="drag"
                class="upload-demo"
                :thumbnail-mode="true"
                :on-error="handleError"
                :on-success="chenggong"
              >
                <img
                  style="width: 100%; height: 100%"
                  v-if="activityForm.bigImageUrl"
                  :src="activityForm.bigImageUrl"
                  class="avatar"
                />
                <div v-else>
                  <i class="el-icon-upload"></i>
                  <div class="el-dragger__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="奖品类型:" required>
              <el-select v-model="activityForm.prizeType" class="activityType">
                <el-option label="必中奖品" value="1"> </el-option>
                <el-option label="随机奖品" value="2"></el-option>
                <el-option label="限量奖品" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="活动是否开启报名:" prop="openJoin" required>
              <el-radio
                v-model="activityForm.openJoin"
                label="0"
                style="margin-left: 15px"
                >不开启报名</el-radio
              >
              <el-radio v-model="activityForm.openJoin" label="1"
                >开启报名</el-radio
              >
              <el-input
                v-model="activityForm.maxJoinCount"
                style="width: 200px; display: inline-block; margin-left: 10px"
                type="number"
                v-if="activityForm.openJoin == '1'"
                placeholder="请输入名额"
              ></el-input>
            </el-form-item>

            <!-- /////////////////////////// -->
            <el-form-item
              label="点击事件"
              prop="clickType"
              class="click-events"
              required
            >
              <el-radio
                v-model="activityForm.clickType"
                label="0"
                style="margin-left: 15px"
                >无跳转</el-radio
              >
              <el-radio v-model="activityForm.clickType" label="1"
                >跳转至URL：</el-radio
              >
              <el-radio v-model="activityForm.clickType" label="2"
                >跳转至已有文章：</el-radio
              >
              <el-radio v-model="activityForm.clickType" label="3"
                >跳转至已有话题：</el-radio
              >
              <el-radio v-model="activityForm.clickType" label="4"
                >跳转至微信小程序：</el-radio
              >
              <el-radio v-model="activityForm.clickType" label="7"
                >跳转至支付宝小程序：</el-radio
              >
              <el-radio v-model="activityForm.clickType" label="5"
                >跳转至音频：</el-radio
              >

              <el-input
                v-model="activityForm.activityUrl"
                class="activityTitle"
                v-if="shieldArray.indexOf(activityForm.clickType) > -1"
                :placeholder="placeholder"
              ></el-input>
            </el-form-item>
            <!-- 小程序 -->
            <div v-if="activityForm.clickType == '4'" class="wx-app">
              <el-form-item
                label="小程序原始Id："
                prop="wxAppId"
                class="wxApp-from"
                required
              >
                <el-input
                  v-model="activityForm.wxAppId"
                  placeholder="请填写正确的小程序原始Id"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="路径地址："
                prop="wxAppUrl"
                class="wxApp-from"
              >
                <el-input
                  v-model="activityForm.wxAppUrl"
                  placeholder="请填写正确的路径地址"
                ></el-input>
              </el-form-item>
            </div>
            <!-- 小程序 -->
            <div v-if="activityForm.clickType == '7'" class="wx-app">
              <el-form-item
                label="小程序原始Id："
                prop="aliAppId"
                class="wxApp-from"
                required
              >
                <el-input
                  v-model="activityForm.aliAppId"
                  placeholder="请填写正确的小程序原始Id"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="路径地址："
                prop="aliAppUrl"
                class="wxApp-from"
              >
                <el-input
                  v-model="activityForm.aliAppUrl"
                  placeholder="请填写正确的路径地址"
                ></el-input>
              </el-form-item>
            </div>

            <!-- 音频 -->
            <div v-if="activityForm.clickType == '5'" class="wx-app">
              <el-form-item
                label="专辑ID："
                prop="albumId"
                class="wxApp-from"
                required
              >
                <el-input
                  v-model="activityForm.albumId"
                  placeholder="请填写专辑ID"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="主播名称："
                prop="nickName"
                class="wxApp-from wx-app"
                required
              >
                <el-input
                  v-model="activityForm.nickName"
                  placeholder="请填写主播名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="单曲数："
                prop="albumCount"
                class="wxApp-from"
                required
              >
                <el-input
                  v-model="activityForm.albumCount"
                  placeholder="请填写单曲数"
                  type="number"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="是否付费："
                prop="isPaid"
                class="wxApp-from"
                required
              >
                <el-radio v-model="activityForm.isPaid" label="1">是</el-radio>
                <el-radio v-model="activityForm.isPaid" label="0">否</el-radio>
              </el-form-item>
            </div>

            <!-- ////////////////////////// -->
            <el-form-item label="APP跑步详情处提示：" prop="runShow">
              <el-radio
                v-model="activityForm.runShow"
                label="1"
                style="margin-left: 15px"
                >关闭</el-radio
              >
              <el-radio v-model="activityForm.runShow" label="0">开启</el-radio>
            </el-form-item>
            <el-form-item label="活动列表展示：" prop="listShow">
              <el-radio
                v-model="activityForm.listShow"
                label="1"
                style="margin-left: 15px"
                >展示</el-radio
              >
              <el-radio v-model="activityForm.listShow" label="0"
                >不展示</el-radio
              >
            </el-form-item>
            <el-form-item
              label="活动图标："
              class="right"
              v-if="activityForm.runShow == '0'"
              prop="smallImageUrl"
            >
              <!-- <el-upload
                :action="actionUrl"
                :with-credentials="true"
                accept="image/*"
                name="uploadFile"
                type="drag"
                :thumbnail-mode="true"
                :on-error="handleError"
                :on-success="handleSuccess" 
               
              >
                <i class="el-icon-upload"></i>
                <div class="el-dragger__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload> -->
              <el-upload
                :action="actionUrl"
                :with-credentials="true"
                accept="image/*"
                name="uploadFile"
                type="drag"
                class="upload-demo"
                :thumbnail-mode="true"
                :on-error="handleError"
                :on-success="handleSuccess"
                :show-file-list="false"
              >
                <img
                  style="width: 100%; height: 100%"
                  v-if="activityForm.smallImageUrl"
                  :src="activityForm.smallImageUrl"
                  class="avatar"
                />
                <div v-else>
                  <i class="el-icon-upload"></i>
                  <div class="el-dragger__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label=" 中奖方式:" prop="rewardType" required>
              <el-radio
                v-model="activityForm.rewardType"
                label="1"
                style="margin-left: 15px"
                >每人每天中奖</el-radio
              >
              <el-radio v-model="activityForm.rewardType" label="2"
                >活动期间内每人中奖</el-radio
              >
              <el-radio v-model="activityForm.rewardType" label="3"
                >所有奖励使用后可再次中奖</el-radio
              >
              <div v-if="activityForm.rewardType != '3'">
                <el-input
                  v-model="activityForm.limitCount"
                  type="number"
                  class="limitCount"
                  required
                ></el-input>
                &nbsp;&nbsp;次
              </div>
            </el-form-item>

            <el-form-item label="起止日期:" required>
              <!-- <el-form-item prop="startTime" class="time" required> -->
              <el-date-picker
                v-model="activityForm.startTime"
                format="yyyy/MM/dd"
                placeholder="yyyy/MM/dd"
                class="qizhiDate"
                style="width: 200px"
              ></el-date-picker>
              <!-- </el-form-item> -->
              至
              <!-- <el-form-item prop="endTime" class="time"> -->
              <el-date-picker
                v-model="activityForm.endTime"
                class="qizhiDate"
                format="yyyy/MM/dd"
                placeholder="yyyy/MM/dd"
                style="width: 200px"
              ></el-date-picker>
              <!-- </el-form-item> -->
            </el-form-item>

            <select-school
              :schObj="activityForm.schObj"
              @changeVal="getVal"
              :isRoot="isRoot"
            ></select-school>
          </el-col>
          <!-- 新增的活动gggggggggg -->
          <el-col :span="12">
            <el-form-item
              label="针对的跑步类型:"
              v-if="activityForm.activityType == '1'"
            >
              <el-checkbox-group
                :min="1"
                v-model="activityForm.activityRunDetail.runType"
              >
                <el-checkbox label="1">计分跑</el-checkbox>
                <el-checkbox label="4">自由跑</el-checkbox>
                <el-checkbox label="3">一起跑</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="是否屏蔽跑步结束页广告:"
              v-if="activityForm.activityType == '1'"
            >
              <el-radio-group
                v-model="activityForm.activityRunDetail.isBindEndAd"
              >
                <el-radio label="0" style="display: inline-block">否</el-radio>
                <el-radio label="1" style="display: inline-block">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="APP跑步结果页活动入口:"
              v-if="activityForm.activityType == '1'"
            >
              <el-radio-group
                v-model="activityForm.activityRunDetail.runEndMsgType"
              >
                <el-radio label="0" style="display: inline-block"
                  >关闭</el-radio
                >
                <el-radio label="1" style="display: inline-block"
                  >开启</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="入口图片:"
              v-if="activityForm.activityRunDetail.runEndMsgType == '1'"
            >
              <!-- <el-upload
                :action="actionUrl"
                :with-credentials="true"
                accept="image/*"
                name="uploadFile"
                type="drag"
                :thumbnail-mode="true"
                :on-error="handleError"
                :on-success="chenggong2" 
                
              >
                <i class="el-icon-upload"></i>
                <div class="el-dragger__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload> -->
              <el-upload
                :action="actionUrl"
                :with-credentials="true"
                accept="image/*"
                name="uploadFile"
                type="drag"
                class="upload-demo"
                :thumbnail-mode="true"
                :on-error="handleError"
                :on-success="chenggong2"
                :show-file-list="false"
              >
                <img
                  style="width: 100%; height: 100%"
                  v-if="activityForm.activityRunDetail.msgPicUrl"
                  :src="activityForm.activityRunDetail.msgPicUrl"
                  class="avatar"
                />
                <div v-else>
                  <i class="el-icon-upload"></i>
                  <div class="el-dragger__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
            <!-- /////////////////////////// -->
            <el-form-item
              label="点击事件:"
              class="click-events"
              v-if="activityForm.activityType == '1'"
            >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="0"
                style="margin-left: 10px"
                >无跳转</el-radio
              >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="1"
                >跳转至URL：</el-radio
              >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="2"
                >跳转至已有文章：</el-radio
              >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="3"
                >跳转至已有话题：</el-radio
              >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="4"
                >跳转至微信小程序：</el-radio
              >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="7"
                >跳转至支付宝小程序：</el-radio
              >
              <el-radio
                v-model="activityForm.activityRunDetail.clickType"
                label="5"
                >跳转至音频：</el-radio
              >

              <el-input
                v-model="activityForm.activityRunDetail.clickUrl"
                class="activityTitle"
                v-if="
                  shieldArray2.indexOf(
                    activityForm.activityRunDetail.clickType
                  ) > -1
                "
                :placeholder="placeholder"
              ></el-input>
            </el-form-item>
            <!-- 小程序 -->
            <div
              v-if="activityForm.activityRunDetail.clickType == '4'"
              class="wx-app"
            >
              <el-form-item label="小程序原始Id：" class="wxApp-from" required>
                <el-input
                  v-model="activityForm.activityRunDetail.wxAppId"
                  placeholder="请填写正确的小程序原始Id"
                ></el-input>
              </el-form-item>
              <el-form-item label="路径地址：" class="wxApp-from">
                <el-input
                  v-model="activityForm.activityRunDetail.wxAppUrl"
                  placeholder="请填写正确的路径地址"
                ></el-input>
              </el-form-item>
            </div>
            <!-- 小程序 -->
            <div
              v-if="activityForm.activityRunDetail.clickType == '7'"
              class="wx-app"
            >
              <el-form-item label="小程序原始Id：" class="wxApp-from" required>
                <el-input
                  v-model="activityForm.activityRunDetail.aliAppId"
                  placeholder="请填写正确的小程序原始Id"
                ></el-input>
              </el-form-item>
              <el-form-item label="路径地址：" class="wxApp-from">
                <el-input
                  v-model="activityForm.activityRunDetail.aliAppUrl"
                  placeholder="请填写正确的路径地址"
                ></el-input>
              </el-form-item>
            </div>

            <!-- 音频 -->
            <div
              v-if="activityForm.activityRunDetail.clickType == '5'"
              class="wx-app"
            >
              <el-form-item label="专辑ID：" class="wxApp-from" required>
                <el-input
                  v-model="activityForm.activityRunDetail.albumId"
                  placeholder="请填写专辑ID"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="主播名称："
                class="wxApp-from wx-app"
                required
              >
                <el-input
                  v-model="activityForm.activityRunDetail.nickName"
                  placeholder="请填写主播名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="单曲数：" class="wxApp-from" required>
                <el-input
                  v-model="activityForm.activityRunDetail.albumCount"
                  placeholder="请填写单曲数"
                  type="number"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否付费：" class="wxApp-from" required>
                <el-radio
                  v-model="activityForm.activityRunDetail.isPaid"
                  label="1"
                  >是</el-radio
                >
                <el-radio
                  v-model="activityForm.activityRunDetail.isPaid"
                  label="0"
                  >否</el-radio
                >
              </el-form-item>
            </div>

            <div
              v-if="['1', '4', '7'].indexOf(activityForm.activityRunDetail.clickType) > -1"
              class="popup-prompt-wrap"
            >
              <el-form-item label="是否弹窗提示" required>
                <div class="popup-prompt-row">
                  <el-radio-group v-model="activityForm.activityRunDetail.isPopup">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <el-input
                    v-if="activityForm.activityRunDetail.isPopup === 1"
                    v-model="activityForm.activityRunDetail.popupContent"
                    maxlength="20"
                    placeholder="请填写弹窗内容，最多20个字"
                    class="popup-prompt-input"
                  ></el-input>
                  <div class="popup-prompt-example">
                    <span class="popup-prompt-example-label">示例</span>
                    <img :src="popupPromptExampleImg" alt="弹窗示例" />
                  </div>
                </div>
              </el-form-item>
            </div>
            <!-- ////////////////////////// -->
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import selectSchool from "../../common/selectSch.vue";
import popupPromptExampleImg from "../../../assets/popup-prompt-example.png";

export default {
  data() {
    let checkStartTime = (rule, value, callback) => {
      let startTime = new Date(this.activityForm.startTime).format(
        "yyyy-MM-dd 00:00"
      );
      startTime = new Date(startTime);
      let endTime = new Date(this.activityForm.endTime).format(
        "yyyy-MM-dd 23:59"
      );
      endTime = new Date(endTime);
      if (startTime.getTime() > endTime.getTime()) {
        callback(new Error("请选择正确的日期"));
      } else {
        callback();
      }
    };

    return {
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      edit: false,
      isRoot: false,
      shieldArray: ["1", "2", "3"],
      shieldArray2: ["1", "2", "3"],
      popupPromptExampleImg,
      activityForm: {
        name: "",
        activityType: "1",
        clickType: "0",
        activityUrl: "",
        prizeType: "1",
        runShow: "1",
        bigImageUrl: "",
        smallImageUrl: "",
        limitCount: "0",
        listShow: "1",
        rewardType: "1",
        qizhiDate: "yyyy/mm/dd",
        startTime: "",
        endTime: "",
        openJoin: "0",
        maxJoinCount: "",
        schObj: {
          applicableCampus: "1",
          shieldedSchools: [], //屏蔽的学校
          openedSchools: [], //应用的学校
        },
        activityCampusList: [],
        wxAppId: "",
        wxAppUrl: "",
        aliAppId: "",
        aliAppUrl: "",
        albumId: "",
        nickName: "",
        albumCount: "",
        isPaid: "0",
        isPopup: 0,
        popupContent: "",
        activityRunDetail: {
          //v2新增
          runType: ["1"], // 跑步类型
          isBindEndAd: "0", //是否屏蔽跑步结束页广告
          runEndMsgType: "0", //app跑步结果页提示
          msgPicUrl: "", //提示入口图片
          clickType: "0", //点击事件类型
          clickUrl: "", //点击事件url
          /* 拼接数据url */
          wxAppId: "",
          wxAppUrl: "",
          aliAppId: "",
          aliAppUrl: "",
          albumId: "",
          nickName: "",
          albumCount: "",
          isPaid: "",
          isPopup: 0,
          popupContent: "",
        },
      },
      rules: {
        smallImageUrl: [{ message: "请上传活动图标", trigger: "change" }],
        bigImageUrl: [
          { required: true, message: "请上传封面图标", trigger: "change" },
        ],
        name: [
          {
            min: 1,
            max: 20,
            message: "请填写正确的名称,不超过20个字符",
            trigger: "blur",
          },
        ],
        limitCount: [
          {
            type: "number",
            min: 1,
            max: 999,
            required: true,
            message: "请填写正确的数字,1-999",
            trigger: "change",
          },
        ],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请填写正确的开始日期",
            trigger: "change",
          },
          { validator: checkStartTime },
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请填写正确的结束日期",
            trigger: "change",
          },
          { validator: checkStartTime },
        ],
      },
    };
  },
  watch: {
    activityForm: {
      handler(n) {
        //console.log("监听表单form", n);
      },
      deep: true,
      immediate: true,
    },
    "activityForm.activityRunDetail.clickType"(val) {
      if (["1", "4", "7"].indexOf(val) === -1) {
        this.activityForm.activityRunDetail.isPopup = 0;
        this.activityForm.activityRunDetail.popupContent = "";
      }
    },
  },
  components: { selectSchool },
  mounted() {
    let url = window.location.href;
    if (url.indexOf("?") !== -1) {
      this.edit = true;
      let activityId = this.$util.getUrlParam("activityId");
      this.getactivityDetail(activityId);
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    placeholder() {
      if (this.activityForm.clickType === "1") {
        return "请填写正确的URL地址";
      } else if (this.activityForm.clickType === "2") {
        return "请填写正确的文章ID";
      } else {
        return "请填写正确的话题ID";
      }
    },
  },
  methods: {
    ...mapActions(["SIGNOUT"]),

    getVal(res) {
      this.activityForm.schObj = res;
    },

    /**新增活动**/
    add() {
      let runShowBoolean, openJoinBoolean;
      let startTime = new Date(
        this.activityForm.startTime.format("yyyy-MM-dd 00:00")
      );
      let endTime = new Date(
        this.activityForm.endTime.format("yyyy-MM-dd 23:59")
      );

      // 验证url地址
      if (
        this.shieldArray.indexOf(this.activityForm.clickType) > -1 &&
        !this.activityForm.activityUrl.trim()
      ) {
        this.$util.errorMsg("点击事件的id或者url不能为空！");
        return;
      }

      if (this.activityForm.clickType === "4") {
        if (!this.activityForm.wxAppId.trim()) {
          this.$util.errorMsg("微信小程序的原始id不能为空！");
          return;
        }
        if (this.activityForm.wxAppId.indexOf("id=") > -1) {
          this.$util.errorMsg("微信小程序的原始id输入格式错误！");
          return;
        }
      }

      if (this.activityForm.clickType === "7") {
        if (!this.activityForm.aliAppId.trim()) {
          this.$util.errorMsg("支付宝小程序的原始id不能为空！");
          return;
        }
        if (this.activityForm.aliAppId.indexOf("appId=") > -1) {
          this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
          return;
        }
      }

      if (this.activityForm.clickType === "5") {
        if (!this.activityForm.albumId.trim()) {
          this.$util.errorMsg("专辑ID不能为空！");
          return;
        }
        if (!this.activityForm.nickName.trim()) {
          this.$util.errorMsg("主播名称不能为空！");
          return;
        }
        var re = /^[0-9]+$/;
        if (
          !this.activityForm.albumCount ||
          !re.test(this.activityForm.albumCount)
        ) {
          this.$util.errorMsg("单曲数输入有误！");
          return;
        }
      }

      /* hhhhhhhhhhhhhhh */
      // 验证url地址2
      if (
        this.shieldArray2.indexOf(
          this.activityForm.activityRunDetail.clickType
        ) > -1 &&
        !this.activityForm.activityRunDetail.clickUrl.trim()
      ) {
        this.$util.errorMsg("点击事件的id或者url不能为空！");
        return;
      }

      if (this.activityForm.activityRunDetail.clickType == "4") {
        if (!this.activityForm.activityRunDetail.wxAppId.trim()) {
          this.$util.errorMsg("微信小程序的原始id不能为空！");
          return;
        }
        if (this.activityForm.activityRunDetail.wxAppId.indexOf("id=") > -1) {
          this.$util.errorMsg("微信小程序的原始id输入格式错误！");
          return;
        }
      }

      if (this.activityForm.activityRunDetail.clickType == "7") {
        if (!this.activityForm.activityRunDetail.aliAppId.trim()) {
          this.$util.errorMsg("支付宝小程序的原始id不能为空！");
          return;
        }
        if (
          this.activityForm.activityRunDetail.aliAppId.indexOf("appId=") > -1
        ) {
          this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
          return;
        }
      }

      if (this.activityForm.activityRunDetail.clickType == "5") {
        if (!this.activityForm.activityRunDetail.albumId.trim()) {
          this.$util.errorMsg("专辑ID不能为空！");
          return;
        }
        if (!this.activityForm.activityRunDetail.nickName.trim()) {
          this.$util.errorMsg("主播名称不能为空！");
          return;
        }
        var re = /^[0-9]+$/;
        if (
          !this.activityForm.activityRunDetail.albumCount ||
          !re.test(this.activityForm.activityRunDetail.albumCount)
        ) {
          this.$util.errorMsg("单曲数输入有误！");
          return;
        }
      }

      if (
        this.activityForm.activityType == "1" &&
        ["1", "4", "7"].indexOf(this.activityForm.activityRunDetail.clickType) > -1 &&
        this.activityForm.activityRunDetail.isPopup === 1 &&
        !this.activityForm.activityRunDetail.popupContent.trim()
      ) {
        this.$util.errorMsg("请填写跑步结果页弹窗内容");
        return;
      }

      if (this.activityForm.runShow == "0") {
        runShowBoolean = true;
      } else {
        runShowBoolean = false;
        this.activityForm.smallImageUrl = "";
      }

      // 整理url入参格式
      if (this.activityForm.clickType == "0") {
        this.activityForm.activityUrl = "";
      } else if (this.activityForm.clickType == "4") {
        // 小程序的id和url作为两个参数拼成字符串传给后台
        if (this.activityForm.wxAppUrl && this.activityForm.wxAppUrl.trim()) {
          this.activityForm.activityUrl =
            "id=" +
            this.activityForm.wxAppId.trim() +
            "&path=" +
            this.activityForm.wxAppUrl.trim();
        } else {
          this.activityForm.activityUrl =
            "id=" + this.activityForm.wxAppId.trim();
        }
      } else if (this.activityForm.clickType == "5") {
        // 音频参数
        this.activityForm.activityUrl =
          "id=" +
          this.activityForm.albumId +
          "&nickName=" +
          this.activityForm.nickName +
          "&count=" +
          this.activityForm.albumCount +
          "&isPaid=" +
          this.activityForm.isPaid;
      } else if (this.activityForm.clickType == "7") {
        // 小程序的id和url作为两个参数拼成字符串传给后台
        if (this.activityForm.aliAppUrl && this.activityForm.aliAppUrl.trim()) {
          this.activityForm.activityUrl =
            "appId=" +
            this.activityForm.aliAppId.trim() +
            "&page=" +
            this.activityForm.aliAppUrl.trim();
        } else {
          this.activityForm.activityUrl =
            "appId=" + this.activityForm.aliAppId.trim();
        }
      }
      // 整理url入参格式222222
      if (this.activityForm.activityRunDetail.clickType == "0") {
        this.activityForm.activityRunDetail.clickUrl = "";
      } else if (this.activityForm.activityRunDetail.clickType == "4") {
        // 小程序的id和url作为两个参数拼成字符串传给后台
        if (
          this.activityForm.activityRunDetail.wxAppUrl &&
          this.activityForm.activityRunDetail.wxAppUrl.trim()
        ) {
          this.activityForm.activityRunDetail.clickUrl =
            "id=" +
            this.activityForm.activityRunDetail.wxAppId.trim() +
            "&path=" +
            this.activityForm.activityRunDetail.wxAppUrl.trim();
        } else {
          this.activityForm.activityRunDetail.clickUrl =
            "id=" + this.activityForm.activityRunDetail.wxAppId.trim();
        }
        //吃饭
      } else if (this.activityForm.activityRunDetail.clickType == "5") {
        // 音频参数
        this.activityForm.activityRunDetail.clickUrl =
          "id=" +
          this.activityForm.activityRunDetail.albumId +
          "&nickName=" +
          this.activityForm.activityRunDetail.nickName +
          "&count=" +
          this.activityForm.activityRunDetail.albumCount +
          "&isPaid=" +
          this.activityForm.activityRunDetail.isPaid;
      } else if (this.activityForm.activityRunDetail.clickType == "7") {
        // 小程序的id和url作为两个参数拼成字符串传给后台
        if (
          this.activityForm.activityRunDetail.aliAppId &&
          this.activityForm.activityRunDetail.aliAppUrl.trim()
        ) {
          this.activityForm.activityRunDetail.clickUrl =
            "appId=" +
            this.activityForm.activityRunDetail.aliAppId.trim() +
            "&page=" +
            this.activityForm.activityRunDetail.aliAppUrl.trim();
        } else {
          this.activityForm.activityRunDetail.clickUrl =
            "appId=" + this.activityForm.activityRunDetail.aliAppId.trim();
        }
      }

      if (this.activityForm.openJoin == "0") {
        openJoinBoolean = false;
        this.activityForm.maxJoinCount = "0";
      } else {
        let value = this.activityForm.maxJoinCount * 1;
        openJoinBoolean = true;
        if (value < 0 || !this.isInt(value) || !value) {
          this.activityForm.openJoin = "1";
          this.$util.errorMsg("请正确填写参与活动的名额");
          return;
        }
      }

      if (
        this.activityForm.schObj.applicableCampus == "1" &&
        this.activityForm.schObj.openedSchools.length == 0
      ) {
        this.$util.errorMsg("请添加应用学校");
        return;
      }

      let rootUnids = [],
        schObj = this.activityForm.schObj;
      if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
        for (let i = 0; i < schObj.shieldedSchools.length; i++) {
          rootUnids.push({
            campusName: schObj.shieldedSchools[i].name,
            unid: schObj.shieldedSchools[i].rootUnid * 1,
          });
        }
      } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
        for (let i = 0; i < schObj.openedSchools.length; i++) {
          rootUnids.push({
            campusName: schObj.openedSchools[i].name,
            unid: schObj.openedSchools[i].rootUnid * 1,
          });
        }
      }

      let url = this.$util.domain + "/adminapi/v2/operate/activity/insert";
      let requestBody = {
        startTime,
        endTime,
        name: this.activityForm.name.trim(),
        activityType: this.activityForm.activityType * 1,
        activityUrl: this.activityForm.activityUrl,
        activityStatus: this.activityForm.activityStatus,
        activityCampusList: rootUnids,
        allUnidFlag: schObj.applicableCampus * 1,
        bigImageUrl: this.activityForm.bigImageUrl,
        clickType: this.activityForm.clickType * 1,
        isPopup: 0,
        popupContent: "",
        limitCount: this.activityForm.limitCount * 1,
        maxJoinCount: this.activityForm.maxJoinCount * 1,
        openJoin: openJoinBoolean,
        prizeType: this.activityForm.prizeType * 1,
        runShow: runShowBoolean,
        listShow: this.activityForm.listShow * 1,
        rewardType: this.activityForm.rewardType * 1,
        smallImageUrl: this.activityForm.smallImageUrl,
        activityRunDetail:
          this.activityForm.activityType != 3
            ? {
                runType: this.activityForm.activityRunDetail.runType.map(
                  (item) => item * 1
                ),
                isBindEndAd:
                  this.activityForm.activityRunDetail.isBindEndAd * 1,
                runEndMsgType:
                  this.activityForm.activityRunDetail.runEndMsgType * 1,
                msgPicUrl: this.activityForm.activityRunDetail.msgPicUrl,
                clickType: this.activityForm.activityRunDetail.clickType * 1,
                clickUrl: this.activityForm.activityRunDetail.clickUrl,
                isPopup:
                  ["1", "4", "7"].indexOf(
                    this.activityForm.activityRunDetail.clickType
                  ) > -1
                    ? this.activityForm.activityRunDetail.isPopup * 1
                    : 0,
                popupContent:
                  ["1", "4", "7"].indexOf(
                    this.activityForm.activityRunDetail.clickType
                  ) > -1 && this.activityForm.activityRunDetail.isPopup === 1
                    ? this.activityForm.activityRunDetail.popupContent.trim()
                    : "",
              }
            : {},
      };
      console.log("提交form", requestBody);
      if (this.edit) {
        //编辑接口
        url = this.$util.domain + "/adminapi/v2/operate/activity/update";
        requestBody.activityId = this.$util.getUrlParam("activityId") * 1;
      }

      this.$http({
        url,
        method: "POST",
        body: JSON.stringify(requestBody),
      }).then((response) => {
        if (response.data.error === 10000) {
          location.href = "/#/yunying/activity/activityManage";
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    // ***判断一个参数是否为正整数；
    isInt(value) {
      if (/^(\+|-)?\d+$/.test(value) && value > 0) {
        return true;
      } else {
        return false;
      }
    },

    //***获取活动详情，用于在编辑页面中展示**//
    getactivityDetail(id) {
      this.id = id;
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/v2/operate/activity/queryByActivityId?activityId=" +
          this.id,
      }).then((response) => {
        console.log("点击修改 新增页中的详情", response.data.data);
        if (response.data.error === 10000) {
          let data = response.data.data;
          data.runShow = data.runShow ? "0" : "1";
          data.openJoin = data.openJoin ? "1" : "0";

          // 点击事件的ID或URL的整理
          let activityUrl = "",
            wxAppId = "",
            wxAppUrl = "",
            aliAppId = "",
            aliAppUrl = "",
            albumId,
            nickName,
            albumCount,
            isPaid = "0";
          if (data.clickType === 4) {
            // 微信小程序地址拆分
            wxAppId = this.$util.getUrlParam("id", data.activityUrl);
            wxAppUrl = this.$util.getUrlParam("path", data.activityUrl);
          } else if (data.clickType === 7) {
            // 支付宝小程序地址拆分
            aliAppId = this.$util.getUrlParam("appId", data.activityUrl);
            aliAppUrl = this.$util.getUrlParam("page", data.activityUrl);
            let query = this.$util.getUrlParam("query", data.targetUrl);
            if (query) {
              aliAppUrl = aliAppUrl + "&query=" + query;
            }
          } else if (data.clickType === 0) {
            activityUrl = "";
          } else if (data.clickType === 5) {
            // 音频
            albumId = this.$util.getUrlParam("id", data.activityUrl);
            nickName = this.$util.getUrlParam("nickName", data.activityUrl);
            albumCount = this.$util.getUrlParam("count", data.activityUrl);
            isPaid = this.$util.getUrlParam("isPaid", data.activityUrl);
          } else {
            activityUrl = data.activityUrl;
          }

          // 点击事件的ID或URL的整理2222
          if (data.activityRunDetail != null) {
            var clickUrl = "",
              wxAppId2 = "",
              wxAppUrl2 = "",
              aliAppId2 = "",
              aliAppUrl2 = "",
              albumId2,
              nickName2,
              albumCount2,
              isPaid2 = 0;
            if (data.activityRunDetail.clickType === 4) {
              // 微信小程序地址拆分
              wxAppId2 = this.$util.getUrlParam(
                "id",
                data.activityRunDetail.clickUrl
              );
              wxAppUrl2 = this.$util.getUrlParam(
                "path",
                data.activityRunDetail.clickUrl
              );
            } else if (data.activityRunDetail.clickType === 7) {
              // 支付宝小程序地址拆分
              aliAppId2 = this.$util.getUrlParam(
                "appId",
                data.activityRunDetail.clickUrl
              );
              aliAppUrl2 = this.$util.getUrlParam(
                "page",
                data.activityRunDetail.clickUrl
              );
              let query = this.$util.getUrlParam("query", data.targetUrl);
              if (query) {
                aliAppUrl2 = aliAppUrl2 + "&query=" + query;
              }
            } else if (data.activityRunDetail.clickType === 0) {
              clickUrl = "";
            } else if (data.activityRunDetail.clickType === 5) {
              // 音频
              albumId2 = this.$util.getUrlParam(
                "id",
                data.activityRunDetail.clickUrl
              );
              nickName2 = this.$util.getUrlParam(
                "nickName",
                data.activityRunDetail.clickUrl
              );
              albumCount2 = this.$util.getUrlParam(
                "count",
                data.activityRunDetail.clickUrl
              );
              isPaid2 = this.$util.getUrlParam(
                "isPaid",
                data.activityRunDetail.clickUrl
              );
            } else {
              clickUrl = data.activityRunDetail.clickUrl;
            }
          }

          this.activityForm = {
            name: data.name || "",
            activityType: data.activityType.toString(),
            smallImageUrl: data.smallImageUrl,
            bigImageUrl: data.bigImageUrl,
            prizeType: data.prizeType + "",
            activityUrl: activityUrl ? activityUrl + "" : "",
            clickType: data.clickType.toString(),
            runShow: data.runShow,
            listShow: data.listShow ? "1" : "0",
            limitCount: data.limitCount || "0",
            rewardType: data.rewardType.toString(),
            openJoin: data.openJoin,
            maxJoinCount: data.maxJoinCount.toString(),
            qizhiDate: "yyyy/MM/dd",
            startTime: new Date(data.startTime),
            endTime: new Date(data.endTime),
            activityCampusList:
              data.allUnidFlag == 0 ? data.activityCampusList : [],
            wxAppId: wxAppId,
            wxAppUrl: wxAppUrl,
            aliAppId: aliAppId,
            aliAppUrl: aliAppUrl,
            schObj: {
              shieldedSchools: [],
              openedSchools: [],
              applicableCampus: data.allUnidFlag ? data.allUnidFlag + "" : "0",
            },
            albumId: albumId,
            nickName: nickName,
            albumCount: albumCount,
            isPaid: isPaid,
            isPopup: data.isPopup != null ? data.isPopup * 1 : 0,
            popupContent: data.popupContent || "",
            /* v2添加的属性 */
            activityRunDetail:
              data.activityRunDetail != null
                ? {
                    //v2新增
                    runType: data.activityRunDetail.runType.map(
                      (item) => item + ""
                    ), // 跑步类型
                    isBindEndAd: data.activityRunDetail.isBindEndAd + "", //是否屏蔽跑步结束页广告
                    runEndMsgType: data.activityRunDetail.runEndMsgType + "", //app跑步结果页提示
                    msgPicUrl: data.activityRunDetail.msgPicUrl, //提示入口图片
                    clickType: data.activityRunDetail.clickType + "", //点击事件类型
                    clickUrl: clickUrl ? clickUrl + "" : "", //点击事件url
                    /* 拼接数据url */
                    wxAppId: wxAppId2,
                    wxAppUrl: wxAppUrl2,
                    aliAppId: aliAppId2,
                    aliAppUrl: aliAppUrl2,
                    albumId: albumId2,
                    nickName: nickName2,
                    albumCount: albumCount2,
                    isPaid: parseInt(isPaid2),
                    isPopup:
                      data.activityRunDetail.isPopup != null
                        ? data.activityRunDetail.isPopup * 1
                        : 0,
                    popupContent: data.activityRunDetail.popupContent || "",
                  }
                : {
                    //v2新增
                    runType: ["1"], // 跑步类型
                    isBindEndAd: "0", //是否屏蔽跑步结束页广告
                    runEndMsgType: "0", //app跑步结果页提示
                    msgPicUrl: "", //提示入口图片
                    clickType: "0", //点击事件类型
                    clickUrl: "", //点击事件url
                    /* 拼接数据url */
                    wxAppId: "",
                    wxAppUrl: "",
                    aliAppId: "",
                    aliAppUrl: "",
                    albumId: "",
                    nickName: "",
                    albumCount: "",
                    isPaid: "",
                    isPopup: 0,
                    popupContent: "",
                  },
          };

          let schArray = data.activityCampusList.map((item) => {
            return { name: item.campusName, rootUnid: item.unid };
          });
          data.allUnidFlag == 0
            ? (this.activityForm.schObj.shieldedSchools = schArray)
            : (this.activityForm.schObj.openedSchools = schArray);
        }
      });
    },
    //**保存**//
    save() {
      this.$refs.activityForm.validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("valid error");
        }
      });
    },
    /**
     * 取消
     **/
    cancel() {
      history.go(-1);
    },
    /**
     *上传文件成功钩子
     **/
    handleSuccess(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.activityForm.smallImageUrl = response.data;
      }
    },
    chenggong(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.activityForm.bigImageUrl = response.data;
      }
    },
    chenggong2(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.activityForm.activityRunDetail.msgPicUrl = response.data;
        console.log(this.activityForm.activityRunDetail.msgPicUrl);
      }
    },
    /**上传文件失败钩子**/
    handleError(response) {
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }

      this.$util.errorMsg("上传失败");
    },
  },
};
</script>
<style>
.btn-activity {
  float: right;
  margin-right: 10px;
}

.newActivity {
  overflow: hidden;
}

.newActivity .click-events .el-radio {
  display: block;
  width: 200px;
}

.newActivity .wxApp-from {
  margin-bottom: 10px;
  margin-left: 120px;
}

.newActivity .wxApp-from .el-input {
  width: 60%;
}

.inline {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 15px;
}

.btn-activity + .btn-activity {
  margin-left: 0;
}

.activityTitle {
  width: 50%;
}

.activitylimitCount {
  width: 15%;
  display: inline-block;
}

.activityType {
  width: 50%;
}

.qizhiDate {
  display: inline-block;
  width: 100%;
}

.activityContent {
  width: 98%;
}

.newActivity .right {
  position: relative;
  left: 70px;
}

.newActivity .time {
  display: inline-block;
  width: 25%;
  margin-right: 17px;
}

.activityTitle_sel {
  display: inline-block;
  margin-left: 20px;
  margin-bottom: 10px;
  width: 20%;
}

.limitCount {
  display: inline-block;
  margin-left: 20px;
  margin-bottom: 10px;
  width: 15%;
}

.mylab {
  color: #1f2d3d;
}
</style>


// WEBPACK FOOTER //
// newActivity.vue?deadc8b0